import { httpStatusOf } from "../api/serverErrors";

/**
 * Классификация ответа сервера по последствиям для дерева.
 *
 * Живёт в домене, а не во view: по 404 нужно убрать объект из дерева, по 403 —
 * закрыть действия и очистить детей. Текст сообщения — уже дело представления.
 */
export type HttpErrorKind = "forbidden" | "notFound" | "other";

export const httpErrorKind = (error: unknown): HttpErrorKind => {
  switch (httpStatusOf(error)) {
    case 403:
      return "forbidden";
    case 404:
      return "notFound";
    default:
      return "other";
  }
};
